module.exports = __webpack_public_path__ + "img/zk-icon-seckill.6c86c922.svg";